import { Theme } from "../../../components/constants";

export default {
	text: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		whiteSpace: 'pre'
	},
	ActivityDetailsPopupCustom: {
		maxHeight: "95vh",
		display: "flex",
		flexDirection: "column",
		width: '50vw',
		maxWidth: '50vw'
	},
	ActivityDetailsPopupChildren: {
		maxHeight: "100%",
		paddingBottom: '50px'
	},
	mainContainer: {
		padding: '20px',
		display: 'flex',
		flexDirection: 'column',
		gap: '30px'
	},
	headerRow: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	actionsRow: {
		display: 'flex',
		alignItems: 'flex-end',
		gap: '40px'
	},
	dateFilter: {
		display: 'flex',
		gap: '20px'
	},
	detailsTable: {
		display: 'flex',
		padding: '20px 40px',
		flexDirection: 'column'
	},
	detailsRow: {
		display: 'flex',
		borderBottom: '1px solid #262626'
	},
	detailsColumn: {
		width: '50%',
		display: 'flex',
		justifyContent: 'center',
	},
	detailsText: {
		fontSize: "16px",
		color: Theme.TEXT_PRIMARY_BLACK,
		textAlign: 'center',
		padding: '10px',
		"word-break": "break-all"
	},
}